import { fetchXsrf, throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { mainStore } from "@/mainStore";
/**
 * Sends a multi-factor authentication generate token request.
 * @param {any} context - The context.
 * @param {function} urlFunc - A function providing the URL for the token generation request.
 * @param {(string|number)} tokenType - The type of token to generate.
 * @param {string} [value] - The value used to generate a token (optional).
 */
export default async function generateToken(context: mainStore, urlFunc: () => Promise<string>, tokenType: string | number, value: string) {
    const url = await urlFunc();
    const formData = new FormData();
    formData.append("tokenType", tokenType.toString());
    if (value) {
        formData.append("value", value);
    }
    const response = await fetchXsrf(context, url, {
        method: "POST",
        credentials: "same-origin",
        body: formData,
    });
    throwIfNonSuccessStatus(response);
    const json = await response.json();
    return json;
}
